const messages = {
  "title": "Dobrodošli u BRIDGESTONE <span class='text-danger'>PLUS</span>",
  "description": "<b>Već imate račun?</b><br/>Prijavite se sa vašom email adresom i lozinkom.<br/><br/><b>Novi ovdje?</b><br/>Ako ste novi korisnik, molimo registrujte se.<br/><br/>",
  "info": "",
  "buttons": {
    "action": "Prijavi se / Registruj se",
    "back": "Nazad na prijavu",
    "changeLanguage": "Promijeni jezik",
    "start": "Počni"
  },
  "languageSelect": {
    "label": "Odabir jezika",
    "description": "Molimo izaberite vaš jezik",
    "start": {
      "bsBA": "Bosanski",
      "hrBA": "Hrvatski",
      "srBA": "Srpski"
    }
  }
}

export default {
  messages
}